import React from 'react'
import { TableCell } from '@mui/material';
import _ from 'lodash'
import { cellTyps } from '../../utils/forecastMonthStaticData';
import { getNumberComma } from '../../utils/numberUtils';

// 상태(등록/수주/진행/실패)별 건수·금액 셀 - "포캐스팅 통계" 전환(2026-10-23).
const ForecastMonthStateCell = ({ headerRows, data }) => {
    if (!headerRows || !data) {
        return null;
    }

    return headerRows && headerRows.map((field, fIndex) => {
        return cellTyps.map((type, tIndex) => {
            let key = `${fIndex}_${tIndex}`;

            let value = _.has(data, `${field.val}.${type.id}`) ? data[field.val][type.id] : '-';
            let formatValue = type.id === 'count' && value !== '-' ? `${getNumberComma(value)} 건` : getNumberComma(value);

            return (
                <TableCell sx={{ width: '90px', paddingLeft: '2px', paddingRight: '2px' }} align="right" key={key}>{formatValue}</TableCell>
            )
        })
    })
}

export default ForecastMonthStateCell
